import { render, staticRenderFns } from "./SubscriptionsOrders.vue?vue&type=template&id=72af215c&scoped=true"
import script from "./SubscriptionsOrders.vue?vue&type=script&lang=js"
export * from "./SubscriptionsOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af215c",
  null
  
)

export default component.exports